import * as React from "react";
const SvgDot = () => /* @__PURE__ */ React.createElement("svg", { width: 16, height: 16, fill: "none" }, /* @__PURE__ */ React.createElement("circle", { cx: 8, cy: 8, r: 4, fill: "currentColor" }));
export default SvgDot;
